import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { liveSessions } from '../../data/liveSessions';
import { VideoCard } from '../../Components/ui/VideoCard/VideoCard';
import { Livesessions } from '../home/livesessions/livesessions';
import youtubeIcon from '../../assets/icons/youtube-icon.svg';
import './livesession.css';

export const Livesession = () => {
  const navigate = useNavigate();
  const featured = liveSessions[0];
  const previous = liveSessions.slice(1);

  const handleSessionClick = (slug) => {
    navigate(`/live-sessions/${slug}`);
  };

  return (
    <div className="ls-page">
      {/* ── Featured Video ── */}
      <section className="ls-featured">
        <Container>
          <div className="ls-featured__player-wrap" onClick={() => handleSessionClick(featured.slug)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleSessionClick(featured.slug)}>
            <img src={featured.thumbnail} alt={featured.title} className="ls-featured__thumb" />
            <button className="ls-featured__play-btn" aria-label="Play video">
              <img src={youtubeIcon} alt="play" className="ls-featured__play-icon" />
            </button>
            <span className="ls-featured__viewers">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              Joined {featured.viewers}
            </span>
            <div className="ls-featured__controls">
              <button className="ls-featured__ctrl-btn" aria-label="Rewind" onClick={(e) => e.stopPropagation()}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-4.95" />
                </svg>
              </button>
              <button className="ls-featured__ctrl-btn" aria-label="Play/Pause" onClick={(e) => e.stopPropagation()}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="white" stroke="none">
                  <rect x="6" y="4" width="4" height="16" /><rect x="14" y="4" width="4" height="16" />
                </svg>
              </button>
              <button className="ls-featured__ctrl-btn" aria-label="Forward" onClick={(e) => e.stopPropagation()}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-.49-4.95" />
                </svg>
              </button>
            </div>
          </div>

          {/* Info row */}
          <div className="ls-featured__info-row">
            <div className="ls-featured__info-left">
              <h3 className="ls-featured__title">{featured.title}</h3>
              <div className="ls-featured__author-row">
                <img src={featured.authorAvatar} alt={featured.authorName} className="ls-featured__author-avatar" />
                <div>
                  <p className="ls-featured__author-name">{featured.authorName}</p>
                  <p className="ls-featured__author-role">{featured.authorRole}</p>
                </div>
              </div>
            </div>
            <div className="ls-featured__actions">
              <button className="ls-featured__action-btn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Download
              </button>
              <button className="ls-featured__action-btn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                </svg>
                Share
              </button>
            </div>
          </div>
        </Container>
      </section>

      {/* ── Asking Questions + Previous Sessions ── */}
      <section className="ls-bottom">
        <Container>
          <Row className="g-5">
            {/* Left — placeholder for questions / comments */}
            <Col xs={12} lg={7}>
              <h3 className="ls-questions__heading">Asking Questions by Participated</h3>
              <div className="ls-questions__input-wrap">
                <input type="text" placeholder="Ask a questions..." className="ls-questions__input" />
                <button className="ls-questions__send" aria-label="Send">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" />
                  </svg>
                </button>
              </div>
              <p className="ls-questions__empty">Be the first to ask a question during the live session.</p>
            </Col>

            {/* Right — Previous Live Sessions */}
            <Col xs={12} lg={5}>
              <h3 className="ls-previous__heading">Previous Live Sessions</h3>
              <div className="ls-previous__list">
                {previous.map((s) => (
                  <Link key={s.id} to={`/live-sessions/${s.slug}`} className="ls-previous__link">
                    <VideoCard
                      thumbnail={s.thumbnail}
                      duration={s.duration}
                      date={s.date}
                      title={s.title}
                      description={s.description}
                      authorAvatar={s.authorAvatar}
                      authorName={s.authorName}
                      authorRole={s.authorRole}
                      hasPlay={s.hasPlay}
                    />
                  </Link>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ── Coming Soon Banner ── */}
      <Livesessions />
    </div>
  );
};
